var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4136 26.9703L13.5593 125.223C12.3459 127.324 11.7038 129.707 11.697 132.133C11.6902 134.56 12.3189 136.946 13.5206 139.054C14.7222 141.162 16.455 142.919 18.5463 144.15C20.6377 145.38 23.0149 146.042 25.4414 146.069H143.15C145.576 146.042 147.954 145.38 150.045 144.15C152.136 142.919 153.869 141.162 155.071 139.054C156.272 136.946 156.901 134.56 156.894 132.133C156.887 129.707 156.245 127.324 155.032 125.223L96.1777 26.9703C94.939 24.9281 93.1948 23.2397 91.1135 22.0679C89.0323 20.8962 86.6841 20.2806 84.2957 20.2806C81.9072 20.2806 79.559 20.8962 77.4778 22.0679C75.3965 23.2397 73.6523 24.9281 72.4136 26.9703Z",
    fill: "#FFC968",
    stroke: "#FFBC42",
    strokeWidth: 7.44489,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2951 62.6859V90.4801",
    stroke: "#FBFBFB",
    strokeWidth: 7.44489,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2951 118.274H84.3624",
    stroke: "#FBFBFB",
    strokeWidth: 7.44489,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.6e8d4f19.svg";
export { ForwardRef as ReactComponent };